module.exports = __webpack_public_path__ + "static/media/favorite.8441583a.svg";